export const get_iso_date = (date) => {
  return new Date(date)?.toDateString();
};

export const addDays = (days) => {
  let date = new Date(); // Current date
  date.setDate(date.getDate() + days); // Add the number of days
  return date;
};
